<template>
  <DashboardBottomCardContent
    :callToActionButtonText="$t('L_create_your_plan')"
    @callToActionCallback="navigateToDebtSolutionsLandingPage"
  >
    <template #icon>
      <v-img
        :src="debtCalculatorIcon"
        alt="debtcalculator-icon"
        width="65"
        max-width="65"
        role="presentation"
        class="ma-0"
      />
    </template>
    <template #content>
      <h4 role="heading" aria-level="3" class="ml-6">
        <span id="header-h2" class="d-block font-weight-bold">{{
          $t('L_how_soon_could_you')
        }}</span>
        <span class="d-block font-weight-regular">{{ $t('L_debt_stacking_can_lead') }}</span>
      </h4>
    </template>
  </DashboardBottomCardContent>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useDebtSolutionsStore } from '@/modules/debtsolutions/store/debtsolutions.store';
import { RouteNames } from '@/router/routeNames';
import debtCalculatorIcon from '../assets/debt-calculator.svg';
import DashboardBottomCardContent from '../../DashboardBottomCardContent.vue';
import { mapStores } from 'pinia';
import { $t } from '@/i18n/i18n.ts';
import type { RouteLocationNormalizedLoaded, Router } from 'vue-router';

export default defineComponent({
  name: 'DebtSolutionsNoPlanBottom',
  components: { DashboardBottomCardContent },
  data() {
    return { debtCalculatorIcon };
  },
  computed: {
    ...mapStores(useDebtSolutionsStore),
  },
  methods: {
    $t,
    async navigateToDebtSolutionsLandingPage(this: {
      $route: RouteLocationNormalizedLoaded;
      $router: Router;
      debtsolutionsStore: ReturnType<typeof useDebtSolutionsStore>;
    }) {
      const route = this.$route;
      const router = this.$router;
      this.debtsolutionsStore.setAddADebtOpenFlag(false);
      if (route.name !== RouteNames.MY_DEBT) {
        await router.push({ name: RouteNames.MY_DEBT });
      }
    },
  },
});
</script>
